












































































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

@Component
export default class BankModal extends Mixins(ModalMixin) {
  form!: CrsForm<'bankAccounts', 'create' | 'update'>;
  @Prop() paymentOptionGroupId!: string;

  @Watch('mode', { immediate: true })
  async switchForm(mode: 'create' | 'update') {
    const paymentOptionGroup = await compass.do('paymentOptionGroups', 'findById', {
      params: { paymentOptionGroupId: this.paymentOptionGroupId },
      select: ['company'],
    });

    this.form = this.$crsForm('bankAccounts', mode, {
      isActive: false,
      name: '',
      bankCode: 0,
      accountingCode: '',
      accountNumber: '',
      branchName: '',
      iban: '',
      currency: 'USD',
      logo: '',
      paymentOptionGroup: this.paymentOptionGroupId,
      company: paymentOptionGroup.data.company,
    });
  }

  async getForm() {
    return compass.do('bankAccounts', 'findOne', { params: { accountId: this.id } });
  }
}
